import React, { Suspense } from 'react';
import { Skeleton, Box } from '@mui/material';

const LazyLoader = ({
    children,
    height = { xs: 180, sm: 240, md: 300, lg: 360 },
    borderRadius = 4,
    marginBottom = 4,
    skeletonProps = {}
}) => {
    return (
        <Suspense
            fallback={
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    sx={{
                        borderRadius,
                        mb: marginBottom,
                        position: 'relative',
                        overflow: 'hidden',
                        minHeight: height,
                        ...skeletonProps.sx
                    }}
                    {...skeletonProps}
                >
                    <Box sx={{ height: '100%' }} />
                </Skeleton>
            }
        >
            {children}
        </Suspense>
    );
};

export default LazyLoader; 